import React from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PackagesDetail from "./pages/PackagesDetail";
import BookingForm from "./pages/BookingForm";
import Privacy from "./pages/Privacy";
import SiteLayout from "./components/SiteLayout";

export default function App() {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/packagesdetail" element={<PackagesDetail />} />
          <Route path="/book" element={<BookingForm />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route
            path="*"
            element={
              <section className="site-container section-space not-found">
                <p className="eyebrow">A LITTLE DETOUR</p>
                <h1>Let’s get you back to the fun.</h1>
                <p>We couldn’t find that page.</p>
                <Link className="button button-primary" to="/">
                  Back to home
                </Link>
              </section>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
